/// <references types="./custom-typings.d.ts" />
import "core-js";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
// import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

// See https://github.com/salvoravida/react-adal
import { runWithAdal } from "react-adal";
import { initializeAuth, authContext, getUserRoleAsync, authEnabled } from "./security/security";
import { loadSettings, settings } from "./settings";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

initializeAuth();

if (authEnabled) {
    runWithAdal(
        authContext,
        async () => {
            loadSettings().then(async () => {

                // AppInsights v2
                const appInsights = new ApplicationInsights({
                    config: { connectionString: settings.applicationInsightsConnection }
                });
                appInsights.loadAppInsights();
                appInsights.trackPageView();
                await getUserRoleAsync();
                ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
            });
        },
        !authEnabled
    );
} else {
    (async () => {
        await getUserRoleAsync();
        ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
    })();
}
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx